import { Injectable } from '@angular/core';
import { HttpSharpenService } from '@services/HttpServices/SharpenHttpService/http-sharpen.service';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SharpenService {
  isPostsLoadingSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  isPostsLoading$: Observable<boolean> = this.isPostsLoadingSubject.pipe(map(count => count > 0));
  isLoadingSubject: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  isLoading$: Observable<boolean> = this.isLoadingSubject.pipe(map(count => count > 0));

  constructor(private httpService: HttpSharpenService) {}

  getAllTracks(page?: number) {
    this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.httpService.getAllTracks(page).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }

  getModulesByIds(ids: number[]) {
    this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.httpService.getModulesByIds(ids).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }

  getModuleById(id: string) {
    this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.httpService.getModuleById(id).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }

  getVideoById(id: number) {
    this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.httpService.getVideoById(id).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }

  trackModuleView(moduleTitle: string, userId: string) {
     this.isLoadingSubject.next(this.isLoadingSubject.getValue() + 1);
    return this.httpService.trackEvent(
      'Modules', 'View Module', moduleTitle, userId
    ).pipe(
      catchError(err => {
        console.log('err', err);
        return of(undefined);
      }),
      finalize(() => this.isLoadingSubject.next(this.isLoadingSubject.getValue() - 1)),
    );
  }
}
